import React from 'react'
import { Page } from '../components/Page';

function NotFound(props) {
    return (
      <Page showToolbar='true'>
        <h1>404 Not Found.</h1>
      </Page>
    )
}

export { NotFound }